module.exports = __webpack_public_path__ + "static/media/templatefiles.9fae83aa.md";